<template>
  <div class="content fx__bgcolor">
    <!-- {{new Date()}} -->
    <div class="container">
      <div style="overflow-y: auto; ">
        <div class="childContainer" v-if="sunTopArr.length > 0">
          <div class="secondContainer">
            <menuItem :Menu="item1" v-for="(item1, index1) in sunTopArr" :key="index1">
            </menuItem>
          </div>
        </div>
        <div class="childContainer">
          <div class="childmenu" v-for="menu in menuGroups" :key="menu.menukey">
            <div class="secondTitle" @click="menuKeyDict[menu.menukey].expand =! menuKeyDict[menu.menukey].expand">
              {{ menu.text }}
              <span class="fa fa-caret-down fa-lg sub_span" :style="`transform: rotate(${!menuKeyDict[menu.menukey].expand ? '-90' : '0'}deg)`"></span>
            </div>
            <div class="secondContainer">
              <menuItem v-for="(menuItem, itemIndex) in menu.children" :key="itemIndex" :Menu="menuItem" :IsFold="!menuKeyDict[menu.menukey].expand">
              </menuItem>
              <div class="IsFold-model" v-if="!menuKeyDict[menu.menukey].expand" @click="menuKeyDict[menu.menukey].expand = !menuKeyDict[menu.menukey].expand"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuItem from "./menuItem"

export default {
  components: { menuItem },
  props: {
    CurrentMenu: Object,
  },
  data() {
    let _menuKeyDict = {}
    _menuKeyDict["other"] = {
      expand: true,
    }
    this.CurrentMenu.children.forEach((element) => {
      let { menukey } = element
      _menuKeyDict[menukey] = {
        expand: true,
      }
    })
    return {
      menuKeyDict: _menuKeyDict,
    }
  },
  computed: {
    menuGroups() {
      let _this = this
      // let menusindex = parseInt(this.$route.params.index);
      // let keyword = this.dSubmenukeyword || "";

      let { text, svg, name, menukey, icon, children } = this.CurrentMenu
      let _arr = []
      let otherArr = {
        text: "其他",
        name: "other",
        menukey: "other",
        // IsFold: true,
        expand: true, //这里的expand是用于记录的
        children: [],
      }
      // let _dingKeyArr = _this.$store.state.core.menuStore.Userding.map(
      //   p => p.name
      // );

      for (const item of children) {
        if (item.children && item.children.length > 0) {
          //把额外属性先赋值好
          let item2 = Object.assign({ expand: true }, true, item)
          // let item2 = Object.assign({}, true, item);
          // if (keyword) {
          //   item2.children = item2.children.filter((p) => p.text.indexOf(keyword) != -1);
          // }

          if (item2.children.length == 0) continue

          item2.children.forEach((p) => {
            p.IsFold = false
            // p.isDing = _dingKeyArr.includes(p.name);
          })
          // if (item2.children.length == 1 && keyword == "") otherArr.children.push(item2.children[0]);
          if (item2.children.length == 1) otherArr.children.push(item2.children[0])
          else {
            // item2.expand = true;
            _arr.push(item2)
          }
        }
      }

      if (otherArr.children.length > 0) {
        _arr.push(otherArr)
      }
      return _arr
    },
    sunTopArr() {
      let _this = this
      // let keyword = this.dSubmenukeyword || "";
      let _arr = []
      // if (keyword) {
      //     _arr = _this.CurrentMenu.children.filter((p) => p.text.indexOf(keyword) != -1);
      // }else{
      _this.CurrentMenu.children.map((p) => {
        if (p.children == undefined || p.children == "undefined") _arr.push(p)
      })
      // }
      return _arr
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background: #ffffff;
  .container {
    height: 100%;
    margin: 10px 0;
    padding-left: 16px;
    overflow-y: scroll;
    overflow-x: hidden;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .submenuinput {
      display: flex;
      justify-content: center;
      align-items: center;
      // margin: 10px 0;
    }
  }
  .offset {
    margin-top: -36px;
    margin-bottom: 20px;
    z-index: 120;
  }
  .parentmenu {
    padding: 23px 20px;
    border-radius: 4px;
    font-size: 18px;
  }
  .childContainer {
    overflow-y: scroll;
    flex: 1;
    // &:hover {
    //   overflow-y: overlay;
    // }
    .childmenu {
      &:last-of-type {
        margin-bottom: 0;
        > div {
          padding-bottom: 0 !important;
        }
      }
    }
    .icon {
      width: 68px;
      height: 68px;
      background: #e73d39;
      border-radius: 16px;
      font-size: 24px;
    }
    .secondTitle {
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      // margin-bottom: 10px;
      .sub_span {
        transform: rotate(0);
        transition: all 0.2s;
      }
    }
    .secondContainer {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      position: relative;
      overflow-x: hidden;
      // margin-bottom: 20px;
      .IsFold-model {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: #ffffff;
        opacity: 0;
      }
    }
  }
}
</style>
